import { useRouteMatch } from 'react-router-dom';

import { isAssignmentType, isExamTemplateType } from '@gmm/ui';
import { useExercise } from '~/lib/hooks';
import { useExamTemplateStore } from '~/work/teacherWork/[exerciseId]/stores/examTemplateStore';

interface UseExerciseStatus {
  isCreatingAssignment: boolean;
  isCreatingExam: boolean;
  isExerciseOpen: boolean;
  isAssignmentOpen: boolean;
  isExamOpen: boolean;
  isLockedExamOpen: boolean;
}

interface Params {
  exerciseType: string;
}

export const useExerciseStatus = (): UseExerciseStatus => {
  const { data: exercise } = useExercise({ readOnly: true });
  const createMatch = useRouteMatch<Params>(
    '/work/:folderId?/create/:exerciseType(exam|assignment)',
  );
  const [targetExam] = useExamTemplateStore(state => [state.examTemplate]);

  const isExistingAssignment = isAssignmentType(exercise);
  const isCreatingAssignment =
    createMatch?.params.exerciseType === 'assignment';
  const isExistingExam = isExamTemplateType(exercise);
  const isCreatingExam = createMatch?.params.exerciseType === 'exam';

  const isExerciseOpen =
    isExistingAssignment ||
    isCreatingAssignment ||
    isCreatingExam ||
    isExistingExam;

  const isExamOpen = isExistingExam || isCreatingExam;

  const isLockedExamOpen = isExamOpen && !!targetExam?.static;

  return {
    isCreatingAssignment,
    isCreatingExam,
    isExerciseOpen,
    isAssignmentOpen: isExistingAssignment || isCreatingAssignment,
    isExamOpen,
    isLockedExamOpen,
  };
};
